import React from "react";
import {
  Flex,
  Text,
  Box,
  useBreakpointValue,
  FlexProps,
} from "@chakra-ui/react";
import Marquee from "react-fast-marquee";

interface LogoMarqueeProps extends FlexProps {
  title?: string;

  logos: {
    name: string;
    logo: string;
  }[];
}

export const LogoMarquee: React.FC<LogoMarqueeProps> = ({
  title = "Trusted by",
  logos,

  ...flexProps
}) => {
  const containerHeight = useBreakpointValue({ base: "230px", md: "268px" });
  const titleFontSize = useBreakpointValue({ base: "18px", md: "18px" });
  const marqueeGap = useBreakpointValue({ base: "24px", md: "40px" });
  const titleMargin = useBreakpointValue({ base: "40px", md: "56px" });

  return (
    <Box
      width="100%"
      height={containerHeight}
      bgColor="#FEFEFE"
      position="relative"
      {...flexProps}
    >
      {/* Title */}
      <Text
        color="prussianBlue.500"
        fontSize={titleFontSize}
        fontWeight={400}
        fontFamily="AeonikPro"
        lineHeight="1.6"
        textAlign="center"
        position="absolute"
        top={titleMargin}
        left="50%"
        transform="translateX(-50%)"
        width={{
          base: "70%",
          md: "100%",
        }}
        px={4}
      >
        {title}
      </Text>

      {/* Logo Marquee */}
      <Box
        position="absolute"
        bottom={{
          base: "50px",
          md: "75px",
        }}
        width="100%"
        height="72px"
      >
        <Marquee autoFill={true} speed={30}>
          {logos.map((company, index) => (
            <Flex
              key={`${company.name}-${index}`}
              alignItems="center"
              mr={marqueeGap}
            >
              <img
                src={company.logo}
                alt={company.name}
                className="min-h-[55px] max-h-[70px] md:min-h-[80px] md:max-h-[80px] min-w-[130px] max-w-[324px] md:max-w-[370px] object-cover"
              />
            </Flex>
          ))}
        </Marquee>
      </Box>

      {/* Bottom border line */}
      <Box
        position="absolute"
        bottom="0"
        width="100%"
        height="0.5px"
        bg="#121212"
      />
    </Box>
  );
};
